import { useMemo } from 'react';
import { getAccountsOptions, getFormConfig } from './helpers';
import { usePortletTranslations } from 'js/components/system/Portlet';

export const useAccountOptions = ({ accounts, isCreditCard }) => {
    const t = usePortletTranslations();

    return useMemo(() => getAccountsOptions({ accounts, isCreditCard, t }), [accounts, isCreditCard, t]);
};

export const useFormConfig = ({ validationConfig, defaultSuggestion, accountFields, accounts }) => useMemo(
    () => getFormConfig({ validationConfig, defaultSuggestion, accountFields, accounts }),
    [validationConfig, defaultSuggestion, accountFields, accounts]
);
